import { HouseDesignInterface } from "@/types/HouseDesignInterface";

export const filterInactiveHouses = (houses: HouseDesignInterface[]) => {
  return houses.filter((house) => house.isActive);
};
